// extracted by mini-css-extract-plugin
export default {"DropZone":"UploadProductImageDialogue_DropZone__8XqKD","Thumbnail":"UploadProductImageDialogue_Thumbnail__Put-7"};